import { BaseService } from './BaseService';

export class CustomInstructionService extends BaseService {
  constructor() {
    super();
  }

  async createCustomInstruction(data) {
    const response = await this.post('/custom-instructions', data);
    return response.data?.instruction || response.instruction;
  }

  async getAllCustomInstructions() {
    const response = await this.get('/custom-instructions');
    return response.data?.instructions || response.instructions || [];
  }

  async getCustomInstructionsForReportType(reportTypeName) {
    const response = await this.get(`/custom-instructions/report-type/${reportTypeName}`);
    let userInstruction = {id: null, content : ''};
    if (response.data.instructions[0]) {
      userInstruction = {id: response.data.instructions[0].id, content: response.data.instructions[0].content};
    } else {
      
      userInstruction = {id: null, content: response.data.combinedInstructions};
      return userInstruction;
    }
    return userInstruction;
  }

  async updateCustomInstruction(id, data) {
    
    const response = await this.put(`/custom-instructions/${id}`, data);
    return response.data?.instruction || response.instruction;
  }

  async deleteCustomInstruction(id) {
    await this.post(`/custom-instructions/delete/${id}`);
  }
}

export default CustomInstructionService;